<template>
  <ion-app>
    <div id="shoppingCart">
      <div xclass="header1">
        <div class="van-hairline--bottom background_color_d6f1ec van-nav-bar" style="z-index: 1;">
          <div class="van-nav-bar__left" v-show="$vuetify.breakpoint.smAndDown">
            <i class="van-icon van-icon-arrow-left van-nav-bar__arrow" style="color: #000000 !important;" @click="$router.back(-1)"></i>
          </div>
          <div class="van-ellipsis van-nav-bar__title">{{ $t("cart.title") }}</div>

          <!--             <div class="van-nav-bar__right">
              <label
                class="img-text-top-middle"
                v-show="!isModifing"
                @click="isModifing = true"
              >Edit</label>
              <label
                class="img-text-top-middle"
                v-show="isModifing"
                @click="isModifing = false"
              >Cancel</label>
          </div>-->
        </div>
      </div>
      <div class="content2">
        <div class="cart-item" v-for="(item, index) in cartItems" :key="index">
          <div style="height: 5px;background-color: #f4f4f4;"></div>
          <div class="div_top_center padding_10">
            <van-checkbox v-model="item.checked" v-show="isModifing">&nbsp;</van-checkbox>
            <img v-lazy="item.ImagePath" class="cart-item-img" />
            <div class="width_100">
              <div style="margin-bottom: 20px;">{{ item.Title }}</div>
              <label class="color_ea0000" style="float: right;width:60px;text-align:right;">{{ item.Price | currency }}</label>

              <van-stepper style="float: right;margin-right: 20px" v-model="item.Quantity" @change="onChangeQuantity(item)"></van-stepper>

              <button class="remove-button" style="float: right;margin-right:20px;" @click="onClickRemove(item)">{{ $t("cart.delete") }}</button>
              <!-- <div x>
              </div>-->
            </div>
          </div>
        </div>
        <div
          class="padding_10 background_color_ffffff"
          style="position: fixed;bottom: 0;border: 1px solid #f4f4f4;width: 96%;padding: 2%;"
          v-show="isModifing"
        >
          <label v-show="allSelected" @click="onClickSelectAll">{{ $t("cart.clearAll") }}</label>
          <label v-show="!allSelected" @click="onClickSelectAll">{{ $t("cart.selectAll") }}</label>
          <label class="float_right" @click="onClickRemove">{{ $t("cart.delete") }}</label>
        </div>

        <div class="modal" v-show="showModal">
          <button class="color_background_8cdbcc color_ffffff option_btn" @click="showModal = false">Pick Up</button>
          <button class="color_background_8cdbcc color_ffffff option_btn" @click="onClickDelivery">Deliver</button>
        </div>
      </div>

      <div class="content2" v-show="cartItems.length == 0">{{ $t("cart.empty") }}</div>

      <div class="checkout-panel" v-show="!isModifing && subtotal > 0">
        <!--             <button
              class="color_background_8cdbcc color_ffffff order_btn"
              v-show="!isModifing"
              @click="showModal = true"
        >{{ $t("cart.checkout") }}</button>-->
        <div class="checkout-panel-content">
          <button class="order_btn" v-show="!isModifing" @click="onClickCheckOut">{{ $t("cart.checkout") }}</button>

          <div class="subtotal-container">
            <label class="subtotal-title" v-show="!isModifing">{{ $t("cart.subtotal") }}</label>
            <label class="subtotal-amount" xclass="color_8b8b8b font_20" v-show="!isModifing">{{ subtotal | currency }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-overlay" v-show="showModal" @click="showModal = false"></div>
  </ion-app>
</template>

<script>
export default {
  data() {
    return {
      cartItems: [],
      allSelected: false,
      isModifing: false,
      showModal: false,
      subtotal: 0,
    };
  },
  computed: {
    member() {
      return this.$store.state.member;
    },
    addresses() {
      return this.$store.state.addresses;
    },
    billingAddress() {
      if (this.addresses == null) {
        return undefined;
      } else {
        return this.addresses.filter((addr) => addr.AddrName == "BILLING")[0];
      }
    },
  },
  mounted() {
    //console.log('shoppingCart mounted');
    //console.log(this.$router.currentRoute);
    if (!this.$enableShoppingCart) this.$router.replace({ name: "home" });
    this.getCartItems();
    //dsBridge.call("get_back_pressed", "2"); // settings for Android go back
  },
  methods: {
    // ------------------------------------------------------------------------ getCartItems
    getCartItems() {
      this.cartItems = [];
      let obj = {
        AppVersion: this.$version,
        language: localStorage.getItem("lang"),
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
      };
      if (this.$store.state.member) {
        if ("Id" in this.$store.state.member) obj.memberId = this.$store.state.member.Id;
      }
      this.$ajax2
        .post("GetCartItems", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            for (let i = 0; i < rpdata.data.data.length; i++) {
              rpdata.data.data[i].checked = false;
              rpdata.data.data[i].Price = rpdata.data.data[i].Price.toFixed(2);
            }
            this.cartItems = rpdata.data.data.detail;
            this.calTotal();
          } else {
            this.$store.commit("member", {});
            window.location.reload();
          }
        })
        .catch((err) => {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ calTotal
    calTotal() {
      let sub = 0;
      for (let i = 0; i < this.cartItems.length; i++) {
        let p = 0;
        if (this.cartItems[i].Price) p = this.cartItems[i].Price;
        let q = 0;
        if (this.cartItems[i].Quantity) q = this.cartItems[i].Quantity;
        sub = sub + q * p;
      }
      this.subtotal = sub.toFixed(2);
    },
    // ------------------------------------------------------------------------ onChangeQuantity
    onChangeQuantity(item) {
      //let $item = item;
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
        productId: item.ProductId,
        quantity: item.Quantity,
      };
      if (this.$store.state.member) {
        if ("Id" in this.$store.state.member) obj.memberId = this.$store.state.member.Id;
      }
      this.$ajax2
        .post("ChangeProductQty", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.calTotal();
            //$item.Quantity = rpdata.data.data.Quantity;
          }
        })
        .catch((err) => {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ onClickSelectAll
    onClickSelectAll() {
      this.allSelected = !this.allSelected;
      for (let i = 0; i < this.cartItems.length; i++) {
        this.cartItems[i].checked = this.allSelected;
      }
    },
    // ------------------------------------------------------------------------ onClickDelete
    onClickRemove(item) {
      /*
      let list = [];
      for (let i = 0; i < this.cartItems.length; i++) {
        if (this.cartItems[i].checked) {
          list.push(this.cartItems[i].ProductId);
        }
      }
      if (list.length == 0) {
        this.$toast({
          message: this.$t("cart.noneSelected"),
          position: "bottom",
        });
        return;
      }
      */
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
        productId: item.ProductId,
      };
      this.$ajax2
        .post("RemoveProductFromCart", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.getCartItems();
          } else {
            this.$toast({
              message: rpdata.data.meta.msg,
              position: "bottom",
            });
          }
        })
        .catch((err) => {}); // eslint-disable-line
    },
    // ------------------------------------------------------------------------ onClickCheckOut
    onClickCheckOut() {
      /*       if (this.billingAddress === undefined) {
        this.$dialog
          .alert({
            message: "You have to set a billing address in order to checkout",
            confirmButtonText: "ok",
          })
          .then(() => {
            this.$router.push({ name: "member" });
          });
      } else {
        this.$router.push({ name: "checkout" });
      } */

      this.$router.push({ name: "checkout" });
    },
    // ------------------------------------------------------------------------
    onClickDelivery() {
      this.$router.push({ name: "checkout" });
    },
    // ------------------------------------------------------------------------
    getSettlement(province) {
      let list = [];
      for (let i = 0; i < this.cartItems.length; i++) {
        if (this.cartItems[i].checked) {
          list.push({
            shopId: this.cartItems[i].shopId,
            num: this.cartItems[i].num,
          });
          // list.push(this.cartItems[i].shopId);
        }
      }
      if (list.length == 0) {
        this.$toast({
          message: this.$t("lang.choiceGoodsPlease"),
          position: "bottom",
        });
        return;
      }
      let obj = {
        province: province,
        shopId: list,
        country: localStorage.getItem("country"),
        language: localStorage.getItem("lang"),
        // yunFei:10
      };
      this.$ajax
        .post("totalPrice", obj, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            if (rpdata.data.data.prompt) {
              this.$dialog
                .alert({
                  message: rpdata.data.data.prompt,
                  confirmButtonText: "ok",
                })
                .then(() => {
                  rpdata.data.data.list = list;
                  this.$store.commit("setBalance", rpdata.data.data);
                  this.$router.push({ name: "balance" });
                });
            } else {
              rpdata.data.data.list = list;
              this.$store.commit("setBalance", rpdata.data.data);
              this.$router.push({ name: "balance" });
            }
          } else {
            this.$toast({
              message: rpdata.data.meta.msg,
              position: "bottom",
            });
          }
        })
        .catch((err) => {}); // eslint-disable-line
    },
  },
};
</script>

<style>
.cart-item {
  /* max-height: 100px; */
}

.cart-item-img {
  height: 100px;
  width: 100px;
  object-fit: contain;
  margin-left: 5px;
  margin-right: 10px;
}

@media screen and (min-width: 600px) {
  .cart-item-img {
    width: 150px;
    height: 150px;
  }
}

.checkout-panel {
  /* position: fixed; */
  /* bottom: 0; */

  border: 1px solid #f4f4f4;
  /* width: 96%; */
  width: 100%;
  padding: 2%;
  z-index: 999;
  padding: 10px;
  background-color: #ffffff;
}

.checkout-panel-content {
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.3);
}

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;

  width: 100%;
  max-width: 60%;
  background-color: #fff;
  border-radius: 16px;

  padding: 25px;
}

.remove-button {
  font-size: 0.8em;
  color: white;
  background-color: red;
  border-style: none;
  border-radius: 15px;
  padding: 5px 10px;
}

.subtotal-container {
  /* position: relative;
  margin-top: auto;
  margin-bottom: auto; */
  float: right;
  /*
  display: flex;
  align-items: center; */
}
.subtotal-title {
  color: #8b8b8b;
  font-size: 0.9em;
}

.subtotal-amount {
  color: black;
  font-size: 1.2em;
  font-weight: bold;
  margin-left: 10px;
}

#shoppingCart .order_btn {
  border: 1px solid #8cdbcc;
  padding: 5px 15px;

  border-radius: 15px;
  background-color: #8cdbcc;
  color: #ffffff;
}
#shoppingCart .option_btn {
  display: block;
  border: 1px solid #8cdbcc;
  margin: 10px 0;
  padding: 10px;
  width: 100%;
  border-radius: 10px;
}
#shoppingCart .submitBtn {
  margin-top: 10%;
  background-color: #8cdbcc;
  width: 100%;
  height: 50px;
  color: #ffffff;
  border: 0;
}
#shoppingCart .addressInput {
  width: 100%;
  border-bottom: 1px solid #f4f4f4 !important;
  border: 0;
  height: 28px;
  line-height: 28px;
}
#shoppingCart .header1 {
  position: fixed;
  width: 100%;
  top: 0;
  box-shadow: 0px 2px 10px lightgrey;
  height: 44px;
  line-height: 44px;
  overflow: hidden;
  width: 100%;
  z-index: 99;
}
#shoppingCart {
  margin-bottom: 50px;
}
#shoppingCart .van-stepper__minus,
.van-stepper__plus {
  width: 21px !important;
  height: 18px !important;
}
#shoppingCart .van-stepper__input {
  width: 21px !important;
  height: 16px !important;
  border-width: 1px !important;
  padding: 0 !important;
}
</style>
